<app-users-table
    [title]="'All Users'"
    [userRoles]="userRoles"
    [filterED]="ed"
    [hideEDColumn]="true"
    [hideRoleColumn]="true"
    [hideRoleFilter]="true"
></app-users-table>
